import { Component, OnInit, AfterViewInit, ViewChild, HostListener, ElementRef } from '@angular/core';
import { ObjectToSelect } from '../../core/shared/objectToSelect.model';
import { HasPermissions, Permissions } from '../../core/services/permissions/permissions.model';
import { GridMainFilter, GoupedColumn, GroupFunction, SortedColumn, GridSelection, SelectionMode } from '../../core/shared/grid/grid.model';
import { GridParamsRestorable } from '../../core/services/grid-params-restoring/grid-params-restoring.model';
import { GridParamsRestoringService } from '../../core/services/grid-params-restoring/grid-params-restoring.service';
import { SpinnerService } from '../../core/services/spinner-handler/spinner-handler.service';
import { MenuButton } from '../../core/shared/tabmenu/tabmenu.model';
import { PermissionsService } from '../../core/services/permissions/permissions.service';
import { DateInputModel } from '../../core/shared/date-input/date-input.model';
import { LoginRest } from '../../login/login.rest';
import { ActivatedRoute, Router } from '@angular/router';
import { GridComponent } from '../../core/shared/grid/grid.component';
import { AbsencesRest } from '../absences.rest';
import { DictionaryRest } from '../../dictionaries/dictionary/dictionary.rest';
import { INgxSelectOption } from 'ngx-select-ex';
import { AbsenceAction, AbsenceRow } from '../absences.model';
import { AbsencesCalendarComponent } from '../absences-calendar/absences-calendar.component';

@Component({
  selector: 'app-absences-list',
  templateUrl: './absences-list.component.html',
  styleUrls: ['./absences-list.component.scss']
})
export class AbsencesListComponent extends GridSelection implements OnInit, AfterViewInit, HasPermissions, GridParamsRestorable {
  readonly detailsPath: string = '/absences/absence';
  permissions: Permissions;
  public path: string;

  public showSuccessMessage: boolean;
  public successMessage: string;

  public currentUser: any;

  //for filters
  public employeeRows: ObjectToSelect[];
  public statusFilters: ObjectToSelect[] = [{ id: 0, name: '&les; Do potwierdzenia', guid: '' }, { id: 1, name: '&les; Zaakceptowany', guid: '' }];
  public absenceTypes: any;
  private selectedStatusFilterId: number;
  private selectedEmployeeId: number;
  private selectedAbsenceTypeId: number;
  private startDate: DateInputModel;
  private endDate: DateInputModel;
  private isRestoredMainFilterDate: boolean = false;

  public initialFilters: any;
  public initialPageNumber = 0;
  public initialPageSize: number;
  public initialSortedColumn: SortedColumn;
  public previousMainFilters: any = {};

  public editedItemId: number;
  private selectedTab = 0; //0-list, 1-calendar
  private isRestoredMainFilter: boolean = false;
  public hideToggles: boolean;
  public expanded: boolean;

  public mainFilter: GridMainFilter[];
  public calendarMainFilter: GridMainFilter[];

  @ViewChild(GridComponent) grid: GridComponent;
  @ViewChild(AbsencesCalendarComponent) absencesCalendar: AbsencesCalendarComponent;

  private isEditable: boolean;
  private isRemovable: boolean;
  private isAdd: boolean;

  private headers = [
    { displayName: 'Pracownik', propertyName: 'employeeFullName', propertyType: 'string' },
    { displayName: 'Zgłaszający', propertyName: 'reporterFullName', propertyType: 'string' },
    { displayName: 'Typ nieobecności', propertyName: 'absenceTypeName', propertyType: 'string' },
    { displayName: 'Od', propertyName: 'startDate', propertyType: 'date', isInitSort: true },
    { displayName: 'Do', propertyName: 'endDate', propertyType: 'date' },
    { displayName: 'Dni nieobecności', propertyName: 'absenceDays', propertyType: 'number' },
    { displayName: 'Status', propertyName: 'stateName', propertyType: 'string' },
    { displayName: 'Opis', propertyName: 'description', propertyType: 'string', showTooltip: true }
  ];

  private columnsToGroup: GoupedColumn[] = [
    { name: 'absenceDays', func: GroupFunction.sum }
  ];

  private gridMenuButtons: MenuButton[] = [
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loginRest: LoginRest,
    private gridParamsRestoringService: GridParamsRestoringService,
    private spinnerService: SpinnerService,
    private permissionService: PermissionsService,
    private dictionaryRest: DictionaryRest,
    private absencesRest: AbsencesRest) {
    super();
    this._grid = this.grid;
    this.onResize();
  }

  ngOnInit() {
    this.spinnerService.show();
    this.mainFilter = new Array();
    this.tryRestoreFiltersAndPage();
    this.setPermissions('Absence');
    this.selectionMode = SelectionMode.multi;

    this.getCurrentUser();
    this.setupAbsenceTypes();
    this.getEmployeesToSelect();
    this.setUpDates();
    this.selectedDates();
    this.path = `api/absences/grid`;
    this.calendarMainFilter = this.mainFilter;
  }

  ngAfterViewInit() {
    this.grid.mainFilter = this.mainFilter;
    this.spinnerService.hide();
  }

  setPermissions(claimType: string): void {
    this.route.data.subscribe(x => {
      this.permissions = this.permissionService.getUserPermissions(x.claimType);
      this.isAdd = this.permissions.canAdd;
      this.isEditable = (this.permissions.canEdit || this.permissions.canShow);
      this.isRemovable = this.permissions.canDelete;
      if (this.isEditable) {
        this.gridMenuButtons.push(
          { text: 'Do potwierdzenia', class: "btn-primary", icon: '', onClick: () => { this.changeState(AbsenceAction.Confirm); }, enabled: this.permissions.canEdit, isForSelected: true },
          { text: 'Potwierdź', class: "btn-primary", icon: '', onClick: () => { this.changeState(AbsenceAction.Approve); }, enabled: this.permissions.canEdit, isForSelected: true },
          { text: 'Odrzuć', class: "btn-warning", icon: '', onClick: () => { this.changeState(AbsenceAction.Reject); }, enabled: this.permissions.canEdit, isForSelected: true },
          { text: 'Anuluj', class: "btn-warning", icon: '', onClick: () => { this.changeState(AbsenceAction.Cancel); }, enabled: this.permissions.canEdit, isForSelected: true }

        );
      }
      this.gridMenuButtons.push(
        { text: 'Usuń', class: "btn-primary", icon: '', onClick: () => { this.deleteSelectedItems(); }, enabled: this.isRemovable, isForSelected: true }
      );

    });
  }

  private onRowEdit(row: any) {
    this.gridParamsRestoringService.saveCurrentGridParams(this.grid, row.id);
    this.router.navigate(['../absences/absence', 'Nieobecność'], { queryParams: { id: row.id }, relativeTo: this.route });
  }

  private onRowAdd(value: any) {
    this.gridParamsRestoringService.saveCurrentGridParams(this.grid);
    this.router.navigate(['../absences/absence/new'], { relativeTo: this.route });
  }

  private deleteSelectedItems() {
    var selectedItems: AbsenceRow[] = this.grid.getSelectedItems();
    if (selectedItems.length == 0) {
      return;
    }
    const selectedIds = selectedItems.map(({ id }) => id);
    sweetAlert('Czy chcesz usunąć wpis nieobecności?', {
      buttons: {
        yes: {
          text: 'Tak',
          value: 'yes'
        },
        no: {
          text: 'Nie',
          value: 'no',
        }
      }
    }).then((value) => {
      switch (value) {
        case 'yes':
          this.absencesRest.deleteSelectedAbsences(selectedIds, this.currentUser.employeeId).subscribe((result: string) => {
            if (result) {
              sweetAlert({ text: result });
            }
            this.grid.refreshData(false);
          });
          break;
      }
    });
  }

  private onRowDelete(row) {
    if (row.stateInternalName != "Buffered") {
      sweetAlert({ text: `Nie można usunąć nieobecności w statusice innym niż niezatwierdzony` });
    }
    else {
      sweetAlert('Czy chcesz usunąć wpis nieobecności?', {
        buttons: {
          yes: {
            text: 'Tak',
            value: 'yes'
          },
          no: {
            text: 'Nie',
            value: 'no',
          }
        }
      }).then((value) => {
        switch (value) {
          case 'yes':
            const action = this.absencesRest.deleteAbsence;
            action.call(this.absencesRest, row.id, this.currentUser.employeeId).subscribe((result: boolean) => {
              if (result) {
                sweetAlert({ text: `Usunięto wpis nieobecności` });
                this.grid.refreshData(false);
              }
            });
            break;
        }
      });
    }
  }

  private tabChanged(tabEvent) {
    switch (tabEvent.index) {
      case 0: //list
        break;

      case 1: //calendar
        this.filter();
        break;

      default:
        break;
    }
  }

  private getCurrentUser() {
    if (!this.isRestoredMainFilter) {
      this.spinnerService.show();
    }
    this.loginRest.GetLoggedUser().subscribe((user: any) => {
      this.currentUser = user;
      this.spinnerService.hide();
    });
  }

  public getEmployeesToSelect() {
    const action = this.absencesRest.getEmployeesToSelect;
    action.call(this.absencesRest).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        this.employeeRows = result.sort((x, y) => x.name > y.name ? 1 : -1);
      }
    });
  }

  private setupAbsenceTypes() {
    this.dictionaryRest.getDictionaries(11).subscribe((dictionaries: any) => {
      this.absenceTypes = dictionaries;
    });
  }

  private setUpDates() {
    this.startDate = new DateInputModel();
    this.startDate.isReadOnly = false;
    this.startDate.isRequired = false;
    this.startDate.withTime = true;
    this.startDate.name = 'Od:';

    if (this.isRestoredMainFilterDate && this.previousMainFilters['StartDate'] && this.isEditable) {
      this.startDate.value = new Date(this.previousMainFilters['StartDate']);
    } else {
      this.startDate.value = new Date();
    }

    this.startDate.value.setHours(0, 0, 0, 0);
    this.startDate.valueStr = this.startDate.value.toDateString();
    this.startDate.internalName = 'StartDate';

    this.endDate = new DateInputModel();
    this.endDate.isReadOnly = false;
    this.endDate.isRequired = false;
    this.endDate.name = 'Do:';

    if (this.isRestoredMainFilterDate && this.previousMainFilters['EndDate'] && this.isEditable) {
      this.endDate.value = new Date(this.previousMainFilters['EndDate']);
    } else {
      var actualDate = new Date();
      actualDate.setDate(actualDate.getDate() + 30);
      this.endDate.value = actualDate;
    }

    this.endDate.value.setHours(23, 59, 59, 0);
    this.endDate.valueStr = this.endDate.value.toDateString();
    this.endDate.internalName = 'EndDate';
  }

  private tryRestoreFiltersAndPage() {
    var previousGridParams = this.gridParamsRestoringService.getPreviousGridParams(this.detailsPath);
    if (!previousGridParams) {
      return;
    }

    this.initialFilters = previousGridParams.initialFilters;
    this.initialPageNumber = previousGridParams.initialPageNumber;
    this.initialSortedColumn = previousGridParams.sortedColumn;
    this.initialPageSize = previousGridParams.initialPageSize;
    this.editedItemId = previousGridParams.editedItemId;
    this.previousMainFilters = previousGridParams.previousMainFilters;

    if (this.previousMainFilters['StartDate']) {
      this.mainFilter.push({ internalName: 'StartDate', value: this.previousMainFilters['StartDate'] });
    }
    if (this.previousMainFilters['EndDate']) {
      this.mainFilter.push({ internalName: 'EndDate', value: this.previousMainFilters['EndDate'] });
    }

    this.isRestoredMainFilterDate = true;
  }

  private setFiltersFromRestoredData() {
    const selectedStatusFilterValue = this.findFilter('StatusFilter');
    this.selectedStatusFilterId = selectedStatusFilterValue != null ? parseInt(selectedStatusFilterValue) : null;
    //this.setFilterOnGrid('ReporterId', this.selectedReporterId != null ? this.selectedReporterId.toString() : null);

    const selectedEmployee = this.findFilter('EmployeeId');
    this.selectedEmployeeId = selectedEmployee != null ? parseInt(selectedEmployee) : null;
    //this.setFilterOnGrid('EmployeeId', this.selectedReporterId != null ? this.selectedEmployeeId.toString() : null);

    const selectedAbsenceType = this.findFilter('AbsenceTypeId');
    this.selectedAbsenceTypeId = selectedAbsenceType != null ? parseInt(selectedAbsenceType) : null;
    //this.setFilterOnGrid('AbsenceTypeId', this.selectedReporterId != null ? this.selectedAbsenceTypeId.toString() : null);

    if (!this.isRestoredMainFilterDate) {
      const startDate = this.findFilter('StartDate');
      if (startDate != null) {
        this.startDate.value = new Date(startDate);
      } else {
        this.startDate.value = new Date();
      }

      this.startDate.value.setHours(0, 0, 0, 0);
      const endDate = this.findFilter('EndDate');
      if (endDate != null) {
        this.endDate.value = new Date(endDate);
      } else {
        var actualDate = new Date();
        actualDate.setDate(actualDate.getDate() + 30);
        this.endDate.value = actualDate;
      }
      this.endDate.value.setHours(23, 59, 59, 0);
    }
  }

  public setGridMainFilterDates() {
    if (this.isRestoredMainFilterDate) {
      this.grid.mainFilter = this.mainFilter;
    }
  }

  private onDateValidation(date: DateInputModel, isValid: boolean) {
    if (!date) {
      return;
    }
    if (date.internalName === 'StartDate' && this.startDate.value > this.endDate.value) {
      this.endDate.value = new Date(date.value);
      this.endDate.value.setHours(23, 59, 59, 0);
    }
    if (date.internalName === 'EndDate' && date.value < this.startDate.value) {
      if (date.value != null) {
        this.startDate.value = new Date(date.value);
        this.startDate.value.setHours(0, 0, 0, 0);
      }
    }
  }

  private selectedDates() {
    let startingdate = null;
    if (this.startDate.value != null) {
      startingdate = this.startDate.value.toJSON();
    }
    this.setFilterOnGrid('StartDate', startingdate);

    let endingDate = null;
    if (this.endDate.value != null) {
      endingDate = this.endDate.value.toJSON();
    }
    this.setFilterOnGrid('EndDate', endingDate);
  }

  private findFilter(internalName: string): string {
    return this.grid.mainFilter.find(x => x.internalName === internalName) && this.grid.mainFilter.find(x => x.internalName === internalName).value || null;
  }

  private setFilterOnGrid(internalName: string, filterValue: string) {
    if (this.mainFilter != null) {
      this.mainFilter.forEach((item, index) => {
        if (item.internalName === internalName) { this.mainFilter.splice(index, 1); }
      });

      if (filterValue !== undefined) {
        this.mainFilter.push({ internalName: internalName, value: filterValue });
      }
      //this.grid.mainFilter = this.mainFilter;
    }
  }

  public filter() {
    this.mainFilter = new Array();
    this.selectedDates();
    if (this.selectedEmployeeId) {
      this.setFilterOnGrid('EmployeeId', this.selectedEmployeeId.toString());
    }

    if (this.selectedAbsenceTypeId) {
      this.setFilterOnGrid('AbsenceTypeId', this.selectedAbsenceTypeId.toString());
    }

    if (this.selectedStatusFilterId != null) {
      this.setFilterOnGrid('StatusFilter', this.selectedStatusFilterId.toString());
    }

    this.refreshData();
  }

  private refreshData() {
    switch (this.selectedTab) {
      case 0:
        this.grid.mainFilter = this.mainFilter;
        this.grid.refreshData();
        break;

      case 1:
        this.absencesCalendar.mainFilter = this.mainFilter;
        this.absencesCalendar.refreshCalendarData();
        break;

      default:
        break;
    }
  }

  private setDefaultfilters() {
    this.selectedStatusFilterId = null;
    this.startDate.value = new Date();
    this.startDate.value.setHours(0, 0, 0, 0);
    var actualDate = new Date();
    actualDate.setDate(actualDate.getDate() + 30);
    this.endDate.value = actualDate;
    this.endDate.value.setHours(23, 59, 59, 0);
  }

  public clearFilter() {
    this.setDefaultfilters();
    this.selectedStatusFilterId = null;
    this.selectedEmployeeId = null;
    this.selectedAbsenceTypeId = null;
    this.filter();
  }

  private searchCallback(search: string, item: INgxSelectOption): boolean {
    search = search.toLowerCase();
    return item.data.name.toLowerCase().includes(search) || item.data.guid.toLowerCase().includes(search);
  }
  private searchCallback2(search: string, item: INgxSelectOption): boolean {
    search = search.toLowerCase();
    return item.data.value.toLowerCase().includes(search);
  }

  private changeState(action: AbsenceAction) {
    let selectedIds = this.getSelectedItemsForAction(action)
    if (selectedIds.length == 0) {
      sweetAlert({ text: `Brak zaznaczonych elementów w odpowiednim statusie dla danej akcji` });
      return;
    }
    this.spinnerService.show();
    this.absencesRest.changeAbsenceStateForMany(selectedIds, action, this.currentUser.employeeId).subscribe((result: string) => {
      if (result) {
        if (result.includes('Błąd')) {
          sweetAlert({ text: result });
        }
        this.grid.refreshData();
      }
      this.spinnerService.hide();
    });
  }

  getSelectedItemsForAction(action: AbsenceAction): number[] {
    let absenceRows: AbsenceRow[] = this.grid.getSelectedItems();
    var state = [];
    switch (action) {
      case AbsenceAction.Approve:
      case AbsenceAction.Reject:
        state = ["ToBeConfirmed"];
        break;
      case AbsenceAction.Cancel:
        state = ["ToBeConfirmed", "Accepted"];
        break;
      case AbsenceAction.Confirm:
        state = ["Buffered"];
        break;
      case AbsenceAction.Init:
      default:
        break;
    }
    var selectedIds = absenceRows.filter(x => state.includes(x.stateInternalName)).map(({ id }) => id);
    return selectedIds;
  }

  @HostListener('window:resize', ['$event'])
  private onResize(event?) {
    if (window.innerWidth <= 768) {
      this.hideToggles = true;
      this.expanded = false;
    } else {
      this.hideToggles = false;
      this.expanded = true;
    }
  }

}